import { createStore } from '@stencil/store';

import { SelectOption } from '../interfaces/interface.banner';
import { DuplicateOfferModal, PreviousVehicle, VinModal } from '../interfaces/interface.landing';
import { YearRange } from '../services/services.eligibility';
import { DynamicEntryInstallationMode, DynamicEntryStep } from '../utils/utils.dynamic-entry';
import { DynamicEntryWorkflow } from '../utils/utils.landing';
import { baseVehicleState } from '../utils/utils.vehicle';

const initialState = {
  ...baseVehicleState,
  dynamicEntryWorkflow: DynamicEntryWorkflow.Unassigned,
  offerCode: 'w',
  dealerId: '00000000-0000-0000-0000-000000000000',
  installationMode: DynamicEntryInstallationMode.Redirect,
  tabList: ['vin', 'plate', 'ymm'],
  tabHeaders: [
    { key: 'vin', label: 'VIN' },
    { key: 'plate', label: 'License Plate' },
    { key: 'ymm', label: 'Make/Model' },
  ],
  defaultSelectedTab: 'vin',
  currentSelectedTab: 'vin',
  enableMakeModel: true,
  inputVin: '',
  licensePlateNumber: '',
  licensePlateState: '',
  inputYmm: '',
  vehiclePossibilities: [] as SelectOption[],
  vehiclePossibilitiesData: [],
  hasMultipleTrims: false,
  ymmSuggestions: [],
  activeStep: DynamicEntryStep.FormSelector,
  vehicleId: 0 as number,
  isFetching: false,
  states: [],
  vinError: '',
  lpError: '',
  furyUrl: null,
  shouldOpenFunnelModal: false,
  ymmError: '',
  styleError: '',
  mileageError: '',
  hasVinError: false,
  hasLPError: false,
  hasYmmError: false,
  hasYmmOption2: false,
  hasStyleError: false,
  hasMileageError: false,
  enableTermsConditions: false,
  shouldShowIneligibleButton: true,
  shouldShowStyleSelection: false,
  isTabRendering: true,
  genericOptions: [] as string[],
  autoCheckData: {},
  yearRange: {} as YearRange,
  vinActiveDealerUrl: '',
  hasVinActiveAutotraderListingError: false,
  sdContainer: '',
  oemDealerCode: '',
  isAssignedOffer: false,
  optimizelyIneligibleVehicleIsActive: false,
  vinModal: {} as VinModal,
  duplicateOfferModal: {} as DuplicateOfferModal,
  invalidVins: [] as string[],
  isComponentRendering: true,
  previousVehicle: null as PreviousVehicle,
  allowIneligibleVehicleSubmission: false,
  cobrandingGroupId: '',
  isCobranding: false,
  mileageRangeValidated: false,
  typicalMileage: 0,
};

const { state, on, onChange, reset } = createStore(initialState);

export { initialState, on, onChange, state, reset };
export default state;
